/**
 * @generated SignedSource<<d46bfe5a013fc9c5f452e86a516e8e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type genericField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "genericField_updateWorkItemFieldsActionRenderer";
};
export type genericField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: genericField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "genericField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "2df905f7f13429193928878e2ea28fe7";

export default node;
